/**
 * React Fullscreen button wrapper
 */

import React, { createRef, Component, ReactNode } from 'react';
import { Button, Fullscreen } from '@bryntum/schedulerpro';

export class BryntumFullscreenButton extends Component {

    private elRef = createRef<HTMLDivElement>();
    private button?:  Button;

    componentDidMount(): void {
        if (Fullscreen.enabled) {
            this.button = new Button({
                adopt      : this.elRef.current as HTMLElement,
                icon       : 'b-icon b-icon-fullscreen',
                tooltip    : 'Fullscreen',
                cls        : 'b-raised b-blue',
                toggleable : true,
                onToggle   : ({ pressed }: { pressed: boolean }) => {
                    pressed ? Fullscreen.request(document.documentElement) : Fullscreen.exit();
                }
            });

            Fullscreen.onFullscreenChange(() => {
                if (this.button) {
                    this.button.pressed = Fullscreen.isFullscreen;
                }
            });
        }
    }

    componentWillUnmount(): void {
        if (this.button) {
            this.button.destroy();
        }
    }

    render(): ReactNode {
        return (
            <div ref={this.elRef} />
        );
    }
}
